export default __webpack_public_path__ + "static/media/regulatory--maximum-speed-limit-led-80--g2.7377246c.png";